import { assertExhaustive } from 'src/app/core/assert-utils';
import { NotificationEntryDto } from '../state/notification.store';

export function getDeliverableIcon(deliverableType: NotificationEntryDto['deliverableType']) {
  switch (deliverableType) {
    case 'DOCUMENT':
      return 'document';
    case 'INTERFACE_INDEX':
    case 'TAG_INDEX':
      return 'data-table';
    case 'MODEL_3D':
      return '3-d-mpr-toggle';
    default:
      assertExhaustive(deliverableType);
  }
}
